import { useContext, useEffect, useRef } from 'react'
import { debounce } from 'lodash'

import { CreateTeacherContext } from '../provider/_context'
import { sendRequestAuth } from '../../../../../api/api'
import useAlert from 'hook/useAlert'
import config from 'config'
import { useCreateProductAction } from '../provider/_action'
import { useParams } from 'react-router-dom'

const useCommissionTable = () => {
    const {showAlert} = useAlert()
    const { teacherId } = useParams()
    
    const { pageState, pageDispatch } = useContext(CreateTeacherContext)
    const commission = pageState.commission;
    const displayList = commission?.list
    const displayLoading = commission?.loading

    // Tạo ref để giữ hàm debounce
    const debouncedPostRef = useRef(null);

    useEffect(() => {
        debouncedPostRef.current = debounce(async (expertData, field, value) => {
            const parsedValue = parseFloat(value || '0');
            const response = await Promise.all([
            sendRequestAuth(
                'post',
                `${config.API}/product-category/update-commission-config/${expertData.config_id}`,
                JSON.stringify({ 
                [field]: parsedValue, 
                user_id: teacherId
                }),
            )
            ]);
            showAlert({
                type: response[0]?.data?.success ? 'info' : 'danger',
                content: response[0]?.data?.message,
            });
        }, 2000);

        return () => {
            debouncedPostRef.current?.cancel(); // cleanup khi unmount
        };
    }, []);


    const handleChangeCommission = (currentData, expertData) => {
        let rawInput = currentData.value;

        // 1. Regex: Chỉ nhận số hoặc số thập phân tối đa 2 chữ số sau dấu .
        const regexNumb = /^(\d+)?(\.\d{0,2})?$/;
        if (!regexNumb.test(rawInput)) {
            return; // ❌ Không đúng định dạng => không làm gì tiếp
        }

        // 2. Xoá số 0 đầu nếu không có "." theo sau
        if (rawInput.length > 1 && rawInput.startsWith("0") && rawInput[1] !== ".") {
            rawInput = rawInput.replace(/^0+/, '');
        }

        const currentVal = parseFloat(rawInput || '0');
        const expertVal = parseFloat(expertData[currentData.equal]) || 0;

        const isInvalid = expertVal < currentVal;

        // ✅ Cập nhật UI cho user thấy
        pageDispatch({
            type: useCreateProductAction.TABLE_UPDATE_CATEGORY_COMMISSION_LIST,
            payload: {
                loading: false,
                list: displayList.map((item) => {
                    if (item.id !== expertData.id) return item;

                    return {
                        ...item,
                        [currentData.field]: rawInput,
                        errorMessageTeacher:
                            currentData.field === 'teacher_commission_principal'
                                ? isInvalid ? "Không vượt quá % HH Manager" : ""
                                : item.errorMessageTeacher,
                    };
                }),
            },
        });

        // ✅ Chỉ gọi API khi đủ điều kiện
        if (!isInvalid && rawInput !== '' && regexNumb.test(rawInput)) {
            debouncedPostRef.current(expertData, currentData.item, rawInput);
        } else {
            debouncedPostRef.current?.cancel(); // 🚫 huỷ debounce nếu sai giá trị logic
        }
    };


    
    return {
        displayList,
        displayLoading,
        handleChangeCommission
    }
}

export default useCommissionTable
